import { Text, Box, SimpleGrid, Skeleton, SkeletonText, Heading } from '@chakra-ui/react';
import { useCcdcCoverage } from '@src/modules/performance/context/reports-api-hooks';

function CcdcCoverageIndicator({ ...rest }) {
  const { data, isLoading } = useCcdcCoverage();

  const ccdc1a = data?.find((item) => item.Code === 'CCDC1a');
  const ccdc1b = data?.find((item) => item.Code === 'CCDC1b');

  if (!data || data.length === 0 || (!ccdc1a?.Value && !ccdc1b?.Value)) return null;

  return (
    <>
      <Heading as="h3" size="sm" my={4}>CCDC Coverage</Heading>
      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4} {...rest}>
        <Box borderWidth="1px" borderRadius="md" p={4} mb={2}>
          <Skeleton isLoaded={!isLoading} width="fit-content" mb={2}>
            <Text fontSize="3xl" fontWeight="bold">
              {ccdc1a?.Value != null ? `${ccdc1a.Value.toFixed(1)}%` : 'N/A'}
            </Text>
          </Skeleton>

          <SkeletonText isLoaded={!isLoading} noOfLines={2}>
            <Text fontSize="xs" color="gray.600">
              Carriageways (Primary Collector and above) with CCDC survey data in
              the last year (
              {ccdc1a?.LockYear || 'N/A'}
              )
            </Text>
          </SkeletonText>
        </Box>

        <Box borderWidth="1px" borderRadius="md" p={4} mb={2}>
          <Skeleton isLoaded={!isLoading} width="fit-content" mb={2}>
            <Text fontSize="3xl" fontWeight="bold">
              {ccdc1b?.Value != null ? `${ccdc1b.Value.toFixed(1)}%` : 'N/A'}
            </Text>
          </Skeleton>

          <SkeletonText isLoaded={!isLoading} noOfLines={2}>
            <Text fontSize="xs" color="gray.600">
              Coverage of CCDC survey data in the last two years (
              {ccdc1b?.LockYear || 'N/A'}
              )
            </Text>
          </SkeletonText>
        </Box>
      </SimpleGrid>
    </>
  );
}

export default CcdcCoverageIndicator;
